import { makeStyles } from 'tss-react/mui';

const useStylesLocationMapMarker: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  locationMapMarkerImageBlock: {
    float: 'left',
  },
  locationMapMarkerTextBlock: {
    maxWidth: 100,
    float: 'right',
    marginLeft: 3,
  },
  locationMapMarkerTextTitle: {
    fontWeight: 500,
  },
  locationMapMarkerTextAmount: {
    marginTop: 3,
  },
  locationMapMarkerImage: {
    maxWidth: 50,
    maxHeight: 50,
    marginRight: 5,
  },
}));

export default useStylesLocationMapMarker;
